'use client';
import { createContext, useContext } from 'react';

export const GlobalContext = createContext<any>({});

export const useGlobal = () => {
    return useContext(GlobalContext);
};
